import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationEL from "./locales/el/translation.json";


const resources = {
    en: {
        translation: translationEN,
    },
    el: {
        translation: translationEL,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "el",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});
